export default "__VITE_PUBLIC_ASSET__98f19a1e__"